module.exports = __webpack_public_path__ + "static/img/app7.88234eb6.png";